import { render, staticRenderFns } from "./InsightForm.vue?vue&type=template&id=5cd65a64&scoped=true"
import script from "./InsightForm.vue?vue&type=script&lang=js"
export * from "./InsightForm.vue?vue&type=script&lang=js"
import style0 from "./InsightForm.vue?vue&type=style&index=0&id=5cd65a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd65a64",
  null
  
)

export default component.exports